export type UnloadQuantityResult =
	| { status: 'empty' }
	| { status: 'valid', value: number }
	| { status: 'invalid', message: string }

/**
 * Resolve a user-typed MTT unload quantity for a bulk/consumable item.
 *
 * Trims surrounding whitespace. Blank input and 0 are 'empty' — the row is
 * simply not unloaded. A whole number from 1 to the available quantity is
 * 'valid'. Anything else (negative, fractional, exponent, non-numeric, or more
 * than available) is 'invalid' with a message telling the user how to fix it,
 * so a bad count is never silently dropped from the unload.
 */
export default function parseUnloadQuantity( raw: string, availableQuantity: number ): UnloadQuantityResult {
	const trimmed = raw.trim()
	if ( trimmed === '' ) {
		return { status: 'empty' }
	}

	if ( !/^\d+$/.test( trimmed ) ) {
		return { status: 'invalid', message: 'Enter a whole number' }
	}

	const value = Number( trimmed )
	if ( value === 0 ) {
		return { status: 'empty' }
	}

	if ( value > availableQuantity ) {
		return { status: 'invalid', message: `Only ${availableQuantity} available` }
	}

	return { status: 'valid', value }
}
